import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { primaryBtn, ghostBtn, card } from './business/useBusiness';
import { bizApi } from '../lib/business';
import { useAuth } from '../contexts/AuthContext';

// /business/invite?token=...: the page an invitation email opens. Joining happens only when the signed-in person presses Accept.
export default function BusinessInvite() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const tok = new URLSearchParams(useLocation().search).get('token') || '';
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const accept = async () => {
    setErr(''); setBusy(true);
    try { await bizApi('/business/invites/accept', { method: 'POST', body: { token: tok } }); navigate('/business/rides', { replace: true }); }
    catch (e) { setErr(e.message); } finally { setBusy(false); }
  };
  return (
    <main className="min-h-screen bg-[#0d0e11] text-gray-50 flex items-center justify-center px-6" data-testid="business-invite">
      <div className={`${card} max-w-md space-y-5`}>
        <h1 className="text-3xl font-semibold tracking-tight">Join a business account</h1>
        {!tok ? <p className="text-base text-gray-300">This invitation link is incomplete. Open the link from your email again.</p>
          : !currentUser ? (
            <>
              <p className="text-base text-gray-300 leading-relaxed">Sign in to RideBuraq with the email address the invitation was sent to (or create an account with it), then open the invitation link again.</p>
              <div className="flex gap-3"><Link to="/login" className={primaryBtn + ' inline-flex items-center'}>Sign in</Link><Link to="/" className={ghostBtn + ' inline-flex items-center'}>Not now</Link></div>
            </>
          ) : (
            <>
              <p className="text-base text-gray-300 leading-relaxed">You are signed in as {currentUser.email}. Accept to join the business account you were invited to.</p>
              {err && <p role="alert" className="text-base text-red-300" data-testid="invite-error">{err}</p>}
              <button type="button" onClick={accept} disabled={busy} className={primaryBtn} data-testid="accept-invite">{busy ? 'Joining…' : 'Accept the invitation'}</button>
            </>
          )}
      </div>
    </main>
  );
}
